import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './eFormEditor.html?raw';
import Properties from './eFormsProperties';
import "./eFormsProperties";

import SearchSelect from '../../moreCore/UI/SearchSelect/SearchSelect';
import "../../moreCore/UI/SearchSelect/SearchSelect";

import DateTimeInput from '../../moreCore/UI/DateTimeInput/DateTimeInput';
import "../../moreCore/UI/DateTimeInput/DateTimeInput";
import "../../moreCore/UI/DateTimeInput/DateTimeInput";
import Edit from '../../moreCore/UI/Edit/Edit';
import "../../moreCore/UI/Edit/Edit";
import domClass from 'dojo/dom-class';
import MultiselectBox from '../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox';
import { FeatureHelpers, ToasterHelpers, TranslationHelpers, UrlHelpers } from "../../more/Helpers";
import _uiFrameMixin from '../../moreCore/UI/Container/uiFrame';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';

class eFormEditor extends compose(_uiFrameMixin) {
    templateString: any = template;

    private inputTypeContainer: HTMLElement;
    //private propertiesContainer: HTMLElement;
    private txtEformType: HTMLElement;
    private txtEformTitle: HTMLElement;
    private iconContainerDraft: HTMLElement;
    private sectionTitle: HTMLElement;
    private sectionType: HTMLElement;
    private sectionTypeHeading: HTMLElement;
    private sectionProperties: HTMLElement;
    private sectionSpecialInfo: HTMLElement;
    private sectionTicketInfo: HTMLElement;
    private sectionComment: HTMLElement;
    private sectionCoeditors: HTMLElement;
    private commentContainer: HTMLElement;
    private tableSpecialNote: HTMLTableElement;
    private txtSpecialNote: HTMLTableCellElement;
    private buttonCheckSpecialConfirmation_Unchecked: HTMLTableCellElement;
    private buttonCheckSpecialConfirmation_Checked: HTMLTableCellElement;
    private txtSpecialConfirmation: HTMLTableCellElement;
    private tableSpecialConfirmation: HTMLTableElement;
    private inputEformTitle: MdsLax<InstanceType<typeof Edit>>;
    private inputComment: HTMLTextAreaElement;
    private inputEformType: MdsLax<InstanceType<typeof SearchSelect>>;
    private inputDateTime: MdsLax<InstanceType<typeof DateTimeInput>>;
    private inputReporter: MdsLax<InstanceType<typeof Edit>>;
    private inputCoeditors: MdsLax<InstanceType<typeof MultiselectBox>>;
    private propertiesTable: MdsLax<InstanceType<typeof Properties>>;

    entityID: string = null;

    private entity: eFormsTypes.eFormEntity = null; // Entity wies aus der Datenbank kommt
    private continuousSaveMode: boolean = false; // wenn true werden Datenänderungen immer gleich in die Datenbank zurückgespielt
    isDirty: boolean = false;
    isDraft: boolean = false;
    private _formDataUndirty: string | eFormsTypes.formData = null;

    private startupState: "new" | "ready" | "loading" = "new";

    private errorCallback: Function = null;
    private successCallback: Function = null;

    private readonly: boolean = false;
    private locked: boolean = false;

    isSpecialConfirmationNeeded: boolean;
    _specialConfirmationStatus: boolean;


    // Objekt mit Werten die beim Speichern übergeben werden (live / immer aktuell)
    formData: eFormsTypes.formData = {
        eformTypeID: null,
        entityID: null,
        comment: null,
        title: null,
        coeditors: null,
        properties: null, // neue Tabelle ab 2021!!
        //_propertyAttributeHelper: "value_text_global" // temporär! wir müssen von value_text auf _global umschalten und die API kennt sich sonst nicht aus...
    };

  
    postCreate() {
        super.postCreate.apply(this, arguments as any);
        this.RequestManager.silentExceptions = true;

        let config = FeatureHelpers.getModule<{ lockLeaseSeconds: number }>("eforms");


        if (config) {
            if (config.lockLeaseSeconds >= 60) {
                this._lockLeaseTimeSec = config.lockLeaseSeconds;
            }
        }

        on(this.propertiesTable, "change", lang.hitch(this, this._onChangeProperties));
        on(this.propertiesTable, "requestEForm", lang.hitch(this, this._onRequestEForm));


    }
    private _loadEntityRequest: dojo.request.Promise<any> = null;
    private _loadEntity(): void {

        if (!this.entityID) return;

        this.startupState = "loading";


        if (this._loadEntityRequest != null) {
            this._loadEntityRequest.cancel();
        }


        this._loadEntityRequest = this.RequestManager.callfunction(
            "Webtool_eForms_API__LoadEform",
            { "eformID": this.entityID },
            lang.hitch(this, this._onLoadEntityResponse),
            lang.hitch(this, this._onLoadEntityError)
        );
    }

    private _onLoadEntityError(error: more.requestErrorMessage) {
        this.StandbyStop();
        this._loadEntityRequest = null;
        alert(error.Message);
    }

    private _onLoadEntityResponse(response: eFormsTypes.eFormEntity): void {
        this._loadEntityRequest = null;

        this.setFormData(response);

        this.StandbyStop();

        this.emit("loaded", response);
    }

    startup() {
        super.startup.apply(this, arguments as any);

        this.RequestManager.handleAs = "json";



        if (!this.entity && !this.entityID) {
            let createVal = UrlHelpers.getUrlParameterValue("ctype");
            if (createVal) {
                this.inputEformType.setValue(createVal, false);
            }
        }

        UrlHelpers.removeUrlParameter("ctype");

        if (!this.entityID && !this.entity) {

        }
        else {
            if (FeatureHelpers.hasFeature("eForms/hideNoteSection")) {

            } else {
                domClass.remove(this.sectionComment, "w3-hide");
            }

            
        }

        if (this.hasFeature("eForms/coEditor")) {
            this.setupCoeditors();
        }
    }
    onClose() {
        this._removeTimeouts();
    }

    onFirstStartup() {
        if (this.entityID && !this.entity && !this._loadEntityRequest) {
            this.inputEformTitle.setReadonly(true);
            this.inputEformTitle.setMandatory(false);

            this._loadEntity();
        }

        this.UiModder.domClass.toggle(this.domNode, "section", this.isEmbeddedInTab);
        this.addButtonEx({
            internalName: "submit",
            label: "eForms__submitBtnLabel",
            enabled: false,
            bCloseOnClick: false,
            callback: lang.hitch(this, this._onClickSubmit, false),
            iconClass: "fas fa-save",
            styleClass: "primaryBG",
            position: "primary",
            order: 1
        });


        if (this.hasFeature("eForms/draft")) {
            this.addButtonEx({
                internalName: "draft",
                label: "eForms__submitDraftBtnLabel",
                callback: lang.hitch(this, this._onClickSubmit, true),
                styleClass: "secondaryBG",
                iconClass: "fas fa-pencil-ruler",
                enabled: false,
                bCloseOnClick: false,
                position: "primary",
                additionalPosition: "primary",
                order: 2 // an die zweite Stelle (also effektiv links neben Speichern) setzen
            });
        }

    }

    private setupCoeditors(): void {
        this.inputCoeditors.valueAttribute = "ID";
        this.inputCoeditors.labelAttribute = "gDisp_Firstname_Name";

        let coeditorsRequestData = {
            "eformID": null
        };

        if (this.entityID) {
            coeditorsRequestData.eformID = this.entityID // achtung, es könnte auch die web-guid sein...
        }

        this.RequestManager.callfunction(
            "Webtool_eForms_API__LoadCoeditors",
            coeditorsRequestData,
            lang.hitch(this, this._onLoadCoeditors),
            lang.hitch(this, this._onLoadCoeditorsError)
        );
    }

    private _onLoadCoeditors(response: { availableList: Array<{ ID: string, gDisp_1: string, gDisp_Firstname_Name: string}>, selectedIds: Array<string>, unselectableIds : Array<string> }) {
        //console.debug("_onLoadCoeditors", response);
        //this.inputCoeditors.setData(response.selectedIds, response.availableList, true);
        this.inputCoeditors.setOptionsEx({
            labels: response.availableList.map(entry => entry.gDisp_Firstname_Name),
            values: response.availableList.map(entry => entry.ID),
            entityData: response.availableList,
            presetValue: response.selectedIds,
            selectable: response.availableList.map(entry => response.unselectableIds .indexOf(entry.ID) == -1 && entry.ID != window.sessionInfo.getCurrentEmployeeId())
        }, true)

        domClass.remove(this.sectionCoeditors, "w3-hide");

    }

    private _onLoadCoeditorsError(error: more.requestErrorMessage) {
        console.error(this.id + " _onLoadCoeditorsError", error.Message);
    }

    setReadonly(value: boolean): void {
        if (value != true && value != false) {
            value = this.readonly;
        }
        this.readonly = value;

        // Reporter editierbar?

        let eFormType: eFormsTypes.eFormType = null;
        if (this.entity != null) {
            eFormType = this.entity.ref_eform_type;
        }

        this.disableNode(this.inputComment, this.readonly);
        //this.UiModder.domClass.toggle(this.sectionProperties, "noInteraction", this.readonly);
        if (this.propertiesTable) this.propertiesTable.setReadOnly(value);

        //  Meldungsart
        //
        if (this.inputEformType != null) {
            this.inputEformType.setReadonly(this.readonly || this.entity != null);
        }

        this.inputEformTitle.setReadonly(this.readonly === true);
        this.inputCoeditors.setReadonly(this.readonly === true);

        //  implement readonly for the table

    }

    

    private _serializeDataHandle: any = null;
    private serializeData_delayed(resetDirtyState?: boolean, bypassReadonly?: boolean, delay?: number): void {
        if (this._serializeDataHandle != null) {
            clearTimeout(this._serializeDataHandle);
            this._serializeDataHandle = null;
        }

        if (!delay || delay < 0) delay = 200;

        this._serializeDataHandle = setTimeout(lang.hitch(this, this.serializeData, resetDirtyState, bypassReadonly), delay);
    }

    private serializeData(resetDirtyState?: boolean, bypassReadonly?: boolean): void {
        //console.debug("eform serializeData (state - reset?)", this.startupState, resetDirtyState);
        if (this._serializeDataHandle != null) {
            clearTimeout(this._serializeDataHandle);
            this._serializeDataHandle = null;
        }
        //dateOfRecord wird einmal direkt gesetzt und kann/darf sich nicht ändern
        //selbiges für reporterID - UPDATE: Reporter ist änderbar

        let entity: eFormsTypes.eFormType = this.inputEformType.get("selectedEntity");
        this.formData.eformTypeID = (entity != null ? entity.ID : null);

        this.formData.coeditors = this.inputCoeditors.getValue();

        this.formData.title = this.inputEformTitle.getValue();

        //this.formData.propertyData = (this.propertyTable != null ? this.propertyTable.getData() : null);
        this.formData.properties = this.propertiesTable._jsonDataOut;

        //if (this.hasUserRole("_DEV")) {
        //    if (this.propertiesTable.isValid != true) {
        //        this.showToast({
        //            title: "DEV: properties invalid",
        //            ID: "invalidProps",
        //            timeout: 2000,
        //            iconClass: "fas fa-times w3-text-red"
        //        });
        //    } else {
        //        this.showToast({
        //            title: "DEV: properties valid",
        //            ID: "invalidProps",
        //            iconClass: ToasterHelpers.ToasterIcons.confirmCheck
        //        });
        //    }
        //}

        this.formData.comment = this.inputComment.value;

        let dirtyFormDataStr = JSON.stringify(this.formData);

        if (resetDirtyState === true) {
            this._formDataUndirty = dirtyFormDataStr;
        }

        if (this.readonly == true && bypassReadonly !== true) { // nicht weitermachen wenns schreibgeschützt ist!
            return;
        }

        if (this.startupState != "ready") return;

        if (this._formDataUndirty) {
            this.setDirty(this._formDataUndirty != dirtyFormDataStr);

        } else {
            this.setDirty(!this._formDataUndirty == null && this.formData != null);
        }

        //console.debug("eform serialized Data (state - reset? - dirty?)", this.startupState, resetDirtyState, this.isDirty);

    }

    checkMandatoryValues(scrollIntoView?: boolean): boolean {

        if (!this.inputEformType.getValue()) {
            return false;
        }

        if (!this.propertiesTable.isValid) {
            // zur fehlenden Eigenschaft wechseln...?
            if (scrollIntoView === true) {
                this.propertiesTable.checkMandatory(null, scrollIntoView);
            }
            return false;
        }

        return true;

    }

    getEntity(): eFormsTypes.eFormEntity {
        return this.entity;
    }

    private _submitInProgess: boolean = false;

    saveForm(saveAsDraft?: boolean): void {

        let bQuitDraft = this.isDraft == true && saveAsDraft !== true;

        // gerade kein Speicherprozess
        // und es muss entweder dirty sein, oder es muss von Entwurf auf Nicht-Entwurf geändert werden
        if (this._submitInProgess !== true && (this.isDirty == true || bQuitDraft)) {

        } else {
            return;
        }

        if (this.isSpecialConfirmationNeeded === true && this._specialConfirmationStatus != true) {
            this.showToast({

                title: TranslationHelpers.translate("eForms__message_specialConfirmationNeeded"),
                timeout: 15000,
                iconClass: ToasterHelpers.ToasterIcons.warning
            });
            return;
        }

        if (this.checkMandatoryValues(!saveAsDraft) === true) {

        } else {
            if (!saveAsDraft) {
               
                return;
            }
        }

        this._submitInProgess = true;

        this.emit("saving");


        this.StandbyStart();


        this.formData.saveAsDraft = saveAsDraft === true;
        this.formData.entityID = this.entityID;

        
        this.RequestManager.callfunction(
            "Webtool_eForms_API__SaveForm",
            this.formData,
            lang.hitch(this, this._onSaveFormDataResponse),
            lang.hitch(this, this._onSaveFormDataError),
            true
        );
    }

    private _onSaveFormDataResponse(response: any): void {

        //this.serializeData(true); // sinnlos, weil laden hinterher eh alles wieder zunichte oder selber macht
        this._submitInProgess = false;
        this._formDataUndirty = this.formData;


        this.showToast({
            title: "eForms__SaveSuccess",
            iconClass: ToasterHelpers.ToasterIcons.confirmCheck,
            ID: "saveResult",
            showClose: false
        });
        
        this.emit("saved");

        UrlHelpers.removeUrlParameter("create");
        UrlHelpers.removeUrlParameter("ctype");


        this.entityID = response.GUID;

        this._loadEntity(); // unbedingt neu laden, weil in Gruppen temporäre GUIDs ersetzt worden sind nach Speichern!

    }

    private _onSaveFormDataError(error: more.requestErrorMessage): void {
        let exception: boolean = true;
        if (this.continuousSaveMode != true) {
            this.StandbyStop();
            this.handleErrorResponse("General_SavingFailed", error.Message);

        }
        this._submitInProgess = false;
        // auch bei live-Speicherung den Benutzer informieren?
    }


    setFormData(entity: eFormsTypes.eFormEntity): void {

        if (entity) this.entity = entity;
        if (!this.entity) return;

        this.hideNode(this.sectionType);
        this.hideNode(this.sectionTypeHeading, false);

        this.txtEformTitle.innerHTML = this.entity.title
        this.txtEformType.innerHTML = this.entity.ref_eform_type.description;
        if (this.entity.ref_eform_type.coloration?.BackColor?.IsNull != true) {
            this.colorNode(this.sectionTypeHeading, this.entity.ref_eform_type.coloration);
        }


        this.startupState = "loading";

        this.entityID = this.entity.ID;

        UrlHelpers.removeUrlParameter("ctype");
        UrlHelpers.removeUrlParameter("create");
        if (UrlHelpers.getUrlParameterValue("view") == false) UrlHelpers.setUrlParameter("view", this.entity.ID);

        this.setTitles(this.entity.title);

        this.isDraft = this.entity.isDraft;
        this.hideNode(this.iconContainerDraft, !this.isDraft);

        if (!this.isDraft) {
            this.removeButton("draft");
        }

        

        this.setReadonly(this.entity.isReadonly || this.locked);

        this.disableNode(this.sectionProperties);
        this._checkEntityLock();

        if (this.entity.EL_ht_eform_property_assignment_eform) {
            this._renderPropertiesTable(this.entity.EL_ht_eform_property_assignment_eform);
        } else this.loadPropertyList();

        this.inputComment.value = this.entity.note;
        this.inputCoeditors.setValue(this.entity.coeditors, true);

        this.inputEformTitle.setValue(this.entity.title);

        this.inputEformType.setValue(this.entity.ref_eform_type, true);

        this.setSpecialInfoFromEformType(this.entity.ref_eform_type);

        this.inputReporter.setValue(this.entity.ref_submitter.gDisp_1);
        this.inputDateTime.setValue(this.entity.date_submitted);
        this.inputDateTime.setReadonly(true);

        this.UiModder.domClass.remove(this.sectionTicketInfo, "w3-hide");

        this.serializeData(true);

        this.setDirty(false); // es ist so: das serializedata führt zu setdirty, aber NUR wenn startupstate auf ready steht.
        // den schalten wir aber erst später auf ready, damit die Properties etc Zeit haben, zu serialisieren und ihr change-event zu feuern und unser undirty-state stimmt.
        // wir möchten aber dennoch den submitbutton aktiv schalten, wenn es readonly und lock und draft zulassen. das setdirty kümmert sich drum

        setTimeout(lang.hitch(this, function () { this.startupState = "ready"; }), 650);
    }



    loadPropertyList(): void {

        this.UiModder.domClass.remove(this.sectionProperties, "w3-hide");



        let data = null;

        // bei einer neuen Meldung muss die Liste aus dem angegebenen Meldungstyp geladen werden
        if (this.entityID == null) {
            if (!this.formData.eformTypeID) {
                this._renderPropertiesTable(null);
                return;
            }
            data = { eformTypeID: this.formData.eformTypeID };
        }
        // bei einer bestehenden Meldung kommt die Liste direkt aus der Meldung
        else {
            data = { eformID: this.entityID };
        }
        this.StandbyStart(this.sectionProperties);

        this.RequestManager.callfunction(
            "Webtool_eForms_API__GetPropertyList",
            data,
            lang.hitch(this, this._onLoadPropertyListResponse),
            lang.hitch(this, this._onLoadPropertyListError),
        );
    }

    private _onLoadPropertyListResponse(response): void {

        this.StandbyStop();
        let entitylist: Array<eFormsTypes.PropertyAssignment> = response;

        this._renderPropertiesTable(entitylist);

    }
    private _onChangeEformTitle() {
        this.serializeData_delayed(this.startupState != "ready", null, 50);

        let title = this.inputEformTitle.getValue();
        let eformType: eFormsTypes.eFormType = this.inputEformType.getValue(true);

        if (!this.entity) {
            if (title || eformType) {
                this.setTitles(TranslationHelpers.translate("General_New") + (title ? " - " + title : eformType ? " - " + eformType.description : ""));
            }
        }
    }

    private _onRequestEForm(targetID: string) {
        this.emit("requestEForm", targetID);
    }

    private _onChangeProperties(data): void {
        //console.debug("_onChangeProperties", this.startupState, data);

        this.serializeData_delayed(this.startupState != "ready", null, 50);
    }

    private _onLoadPropertyListError(error): void {
        this.StandbyStop();
        this.handleErrorResponse(undefined, error.Message);
        //alert(error.Message);
    }

    private _onChangeEformType(selectedValue: string): void {
        if (this.readonly) return;

        this.serializeData(!this.entityID);

        if (this.startupState != "loading" ) this.startupState = "ready";


        if( !this.entityID) this.loadPropertyList();

        if (selectedValue == null) {
            //console.log(" selectedValue == null")
            return;
        }

        let eformType: eFormsTypes.eFormType = this.inputEformType.getValue(true);

        if (!eformType) {
            return;
        }
        

        this.setSpecialInfoFromEformType(eformType);

        if (this.entity == null) {
            this.setUrlParameter("create", selectedValue);
            let title = this.inputEformTitle.getValue();
            if (!title) {
                this.setTitles(TranslationHelpers.translate("General_New") + ( eformType ? " - " + eformType.description : ""));
            }
        }
    }

    private _onChangeCoeditors(data): void {
        //console.debug("_onChangeCoeditors", data, this.inputCoeditors.getValue());

        if (this.readonly === true) return;

        if (this.startupState == "ready" ) this.serializeData();

    }

    private _onChangeEformDateTime(evt): void {
        //console.log("change datetime event");
    }

    private _onchangeEformDate(evt): void {
        //console.log("change date event");
    }

    private _onChangeComment(evt): void {
        if (this.readonly === true) return;

        this.formData.comment = this.inputComment.value.trim().replace(/\s+/g, " "); //überflüssiges whitespace entfernen
        this.serializeData();
    }

    private setSpecialInfoFromEformType(eformType: eFormsTypes.eFormType): void {
        
        if (!eformType) {
            this.hideNode(this.sectionSpecialInfo);
            this.setSpecialConfirmation(null);
            this.setSpecialNote(null);
            return;
        }

        eformType.is_show_special_note == true || eformType.is_show_special_confirmation == true ? this.UiModder.domClass.remove(this.sectionSpecialInfo, "w3-hide") : this.UiModder.domClass.add(this.sectionSpecialInfo, "w3-hide");

        this.entityID != null ? this.UiModder.domClass.add(this.sectionSpecialInfo, "w3-disabled") : this.UiModder.domClass.remove(this.sectionSpecialInfo, "w3-disabled");

        this.setSpecialConfirmation(eformType.is_show_special_confirmation == true ? eformType.special_confirmation_text : "");
        this.setSpecialNote(eformType.is_show_special_note == true ? eformType.special_note : "");

    }

    private setSpecialNote(text: string): void {
        if (!text) {
            text = "";
            this.UiModder.domClass.add(this.tableSpecialNote, "w3-hide");
        } else {
            this.UiModder.domClass.remove(this.tableSpecialNote, "w3-hide");
        }

        this.UiModder.domAttr.set(this.txtSpecialNote, "innerHTML", text);
    }

    private setSpecialConfirmation(text: string): void {
        if (!text) {
            text = "";
            this.isSpecialConfirmationNeeded = false;
            this.UiModder.domClass.add(this.tableSpecialConfirmation, "w3-hide");
        } else {
            this.UiModder.domClass.remove(this.tableSpecialConfirmation, "w3-hide");
            this.isSpecialConfirmationNeeded = true;
        }

        this.setSpecialConfirmationStatus(this.entityID != null);

        this.UiModder.domAttr.set(this.txtSpecialConfirmation, "innerHTML", text);
    }

    private _onClick_SpecialConfirmation(evt): void {

        if (this.isSpecialConfirmationNeeded != true || this.readonly === true) {
            return;
        }
        this.setSpecialConfirmationStatus(this._specialConfirmationStatus !== true);
    }

    setSpecialConfirmationStatus(targetState: boolean): void {
        this._specialConfirmationStatus = targetState;

        this.serializeData();

        this.setSpecialConfirmationStatusStyle();
    }

    setSpecialConfirmationStatusStyle(): void {
        if (this.readonly === true) {
            this.UiModder.domClass.remove(this.tableSpecialConfirmation, "mds-hover-dark");
        } else {
            this.UiModder.domClass.add(this.tableSpecialConfirmation, "mds-hover-dark");
        }
        if (this._specialConfirmationStatus === true) {
            this.UiModder.domClass.add(this.buttonCheckSpecialConfirmation_Unchecked, "w3-hide");
            this.UiModder.domClass.remove(this.buttonCheckSpecialConfirmation_Checked, "w3-hide");
        } else {
            this.UiModder.domClass.remove(this.buttonCheckSpecialConfirmation_Unchecked, "w3-hide");
            this.UiModder.domClass.add(this.buttonCheckSpecialConfirmation_Checked, "w3-hide");
        }
    }
    private _lockCheckHandle: number = null;

    private _checkEntityLock() {

        if (!this.hasFeature("eForms/Locking")) {
            this._onCheckEntityLockResult({ isLocked: false, eformID: this.entityID });
            return;
        }
        if (this._lockCheckHandle) {
            try {
                clearTimeout(this._lockCheckHandle);
            } catch (ex) {

            }
        }
        this._lockCheckHandle = null;

        if (!this.entity) {
            //console.warn("tried to check entitylock without entity");
            this.removeToast("entityLocked");

            return;
        }

     
        let data = {
            "eformID": this.entity.ID,
        };

        this.RequestManager.callfunction(
            "Webtool_eForms_API__CheckLock",
            data,
            lang.hitch(this, this._onCheckEntityLockResult),
            lang.hitch(this, this._onCheckEntityLockError)
        );
    }

    private _onClick_ReloadLockedEntity(evt: MouseEvent) {
        // wir müssen davon ausgehen, dass bei einem lock wirklich aktuell jemand am Entity arbeitet
        // also müssen etwaige Änderungen ja sowieso geladen werden
        if (this.entityID) {
            this._loadEntity();
        }
    }

    private _onCheckEntityLockResult(result: { "isLocked": boolean, "eformID": string }) {
        if (this.entity && result.eformID) {
            if (result.isLocked) {
                this.locked = true;
                this.setReadonly(true);
                this.setDirty(false);


                ToasterHelpers.showToast({
                    title:"eForms__Toast_EntityCurrentlyLocked",
                    iconClass: ToasterHelpers.ToasterIcons.info,
                    timeout: 40 * 1000,
                    showClose: false,
                    options: {
                        ID: "entityLocked",
                        hideTimeoutProgress: true,
                        buttons: [
                            {
                                callback: lang.hitch(this, this._onClick_ReloadLockedEntity),
                                icon: ToasterHelpers.ToasterIcons.redo,//"fas fa-reload",
                                label: "eForms__ToastBtn_ReloadEntityLock",
                            }
                        ]
                    }
                });
                
                if (this._lockEntityDelayedHandle) {
                    clearTimeout(this._lockEntityDelayedHandle);
                }

                this._lockCheckHandle = setTimeout(lang.hitch(this, this._checkEntityLock), 30 * 1000);
            } else {
                this.removeToast("entityLocked");

               

                // falls es davor gelockt war, ist es noch readonly.
                // etwaige Änderungen in der Zwischenzeit aufholen und das Entity frisch laden:

                if (this.locked) {

                    if (this.hasUserRole("_DEV") && FeatureHelpers.hasFeature("eforms/_debugLocking")) {
                        this.showToast({
                            title: "Entity is not locked. Reloading after readonly...",
                            iconClass: "fas fa-lock-open w3-text-gray",
                            ID: "locking",
                            timeout: "permanent"
                        });

                        console.debug("not locked. currently readonly?", this.readonly);
                    }
                    this.locked = false;
                    this._loadEntity();
                    return;
                    // danach raus, weil bei der Response eh nochmal ein checkLock gemacht wird, dann kommen wir wieder hierher, aber nicht ins if
                }

                this.disableNode(this.sectionProperties, false);


                if (this.hasUserRole("_DEV") && FeatureHelpers.hasFeature("eforms/_debugLocking")) {
                    this.showToast({
                        title: "Entity is not locked. Creating lock...",
                        iconClass: "fas fa-lock-open w3-text-gray",
                        ID: "locking",
                        timeout: "permanent"
                    });

                    console.debug("not locked. currently readonly?", this.readonly);
                }

                this._lockEntityForOthers();
            }
        }
    }

    private _onCheckEntityLockError(error: more.requestErrorMessage) {
        if (this.hasUserRole("_DEV") && FeatureHelpers.hasFeature("eforms/_debugLocking")) {
            console.warn("checking entitylock failed", error.Message);

            this.showToast({
                title: "checking entitylock failed",
                iconClass: "fas fa-lock w3-text-red"
            });
        }

        this._lockCheckHandle = setTimeout(lang.hitch(this, this._checkEntityLock), 5 * 1000);
    }

    private _lockLeaseTimeSec: number = 300;
    private _lockEntityForOthers(release?: boolean, leaseTimeMinutes: number = 5) {

        if (!this.hasFeature("eForms/Locking")) {
            return;
        }
        if (!this.entity.ID) {
            console.warn("tried to lock eform without entity ID");
            return;
        }

        if (this._lockEntityDelayedHandle != null) clearTimeout(this._lockEntityDelayedHandle);

        this._lockEntityDelayedHandle = null;

        ////TMP:
        //this._onLockEntityResult(false, "success");
        //return;



        let data = {
            "eformID": this.entity.ID,
            "bUnlock": release === true,
            "leaseTimeMinutes": Math.ceil(this._lockLeaseTimeSec / 60)
        };


        this.RequestManager.callfunction(
            "Webtool_eForms_API__CreateLockLease",
            data,
            lang.hitch(this, this._onLockEntityResult, release === true),
            lang.hitch(this, this._onLockEntityError, release === true),
            true
        );

        if (this.hasUserRole("_DEV") && FeatureHelpers.hasFeature("eforms/_debugLocking")) {
            this.showToast({
                title: release ? "unlocking..." : "locking...",
                ID: "locking",
                iconClass: "fas fa-cogs"
            });
        }
    }

    private _lockEntityDelayedHandle: number = null;

    private _releaseTimeout: number;
    private _releaseLock(): void {
        this._lockEntityForOthers(true);
    }

    private _onLockEntityResult(release: boolean, result: string) {

        this.removeToast("locking");

        if (!this.hasFeature("eForms/Locking")) {
            release = true;
        }
        if (this._destroyed) return;

        if (release) {
            if (this.hasUserRole("_DEV") && FeatureHelpers.hasFeature("eforms/_debugLocking")) {
                console.info("entity unlocked", this.entity.ID);

                this.showToast({
                    title: "entity unlocked",
                    ID: "unlocked",
                    iconClass: "fas fa-lock-open w3-text-green"
                });
            }
        } else {

            if (this.hasUserRole("_DEV") && FeatureHelpers.hasFeature("eforms/_debugLocking")) {
                console.info("entity locked for another interval", this.entity.ID);

                this.showToast({
                    title: "entity locked for another interval",
                    ID: "lock",
                    iconClass: "fas fa-lock w3-text-red",
                    timeout: Math.ceil(this._lockLeaseTimeSec * 1000)
                });
            }

            this._lockCheckHandle = setTimeout(lang.hitch(this, this._checkEntityLock), this._lockLeaseTimeSec * 1000 - 30000);

            // wenns gelockt ist, dann das Release in einigen Minuten durchführen, falls es bis dahin kein onchanged mit dirty gab etc
            if (this._releaseTimeout) {
                clearTimeout(this._releaseTimeout);
            }
            // neues release:
            this._releaseTimeout = setTimeout(lang.hitch(this, this._releaseLock), this._lockLeaseTimeSec * 1000 + 30000);

        }

    } private _onLockEntityError(release: boolean, error: string) {
        this.removeToast("locking");
        if (this._destroyed) return;
        if (release) {
            if (this.hasUserRole("_DEV") && FeatureHelpers.hasFeature("eforms/_debugLocking")) {

                console.info("entity unlocking failed!", this.entity.ID);
                this.showToast({
                    title: "entity unlocking failed",
                });
            }
        } else {
            if (this.hasUserRole("_DEV") && FeatureHelpers.hasFeature("eforms/_debugLocking")) {
                console.info("entity locking failed! retry...", this.entity.ID);

                this.showToast({
                    title: "entity locking failed! retry...", 
                });
            }

            //this.toaster.addToast(TranslationHelpers.translate("eForms__Toast_LockingEntityFailed"], toasterIcons.warning, { ID: "locking", timeout: 5000 });
            this._lockCheckHandle = setTimeout(lang.hitch(this, this._checkEntityLock), 5 * 1000);
        }
    }



    private setDirty(value: boolean): void { 

        
        //if (this.readonly === true) return;
        if (this.readonly || this.locked) {
            this.disableButton("submit");
            this.disableButton("draft");
            return;
        }

        if (this.isDirty != value) {
            this.isDirty = value;
            this.emit("dirty", this.isDirty);

            this.enableButton("draft", this.isDirty);
        }

        let bAltEnableSubmit = false;
        if (this.isDraft) {
            bAltEnableSubmit = true;// this.checkMandatoryValues();
        }

        this.enableButton("submit", this.isDirty || bAltEnableSubmit);


        // jedes mal wenn aktiv was geändert wird: ein Lock für die nächsten 5 Minuten erzeugen
        if (this.entity) {
            // lock erneuern:
            if (!this._lockEntityDelayedHandle) {
                this._lockEntityDelayedHandle = setTimeout(lang.hitch(this, this._lockEntityForOthers), 15 * 1000);
            }
        }
    }

    private _renderPropertiesTable(propertyList: Array<eFormsTypes.PropertyAssignment>): void {

        //this.disableNode(this.sectionProperties, this.readonly);

        this.propertiesTable.setData(propertyList); // NEUE TABLLE 2021!!

        if (propertyList == null || typeof (propertyList) == "undefined") {
            //this.UiModder.domClass.add(this.sectionProperties, "w3-disabled");
            this.disableNode(this.sectionProperties);
            return;
        }

        this.hideNode(this.sectionProperties, false);
        this.disableNode(this.sectionProperties, false);

        this.propertiesTable.setReadOnly(this.readonly === true || this.locked === true);
    }

    private _onClickSubmit(bSaveAsDraft: boolean, dlgResult: number): void {
        if (typeof (dlgResult) != "number") dlgResult = -99; // je nach lang.hitch kann auch das clickevent daherkommen

        if (!bSaveAsDraft) {
            if (!this.checkMandatoryValues(true)) {
                this.showToast({
                    title: "eForms__message_incompleteData",
                    iconClass: ToasterHelpers.ToasterIcons.warning,
                    ID: "saveError",
                    timeout: 7000
                });
                return;
            }
        }
        
        if (bSaveAsDraft === true) {
            this.saveForm(bSaveAsDraft);
            return;
        } else if (dlgResult >= 2) {
            // hier kommen wir rein, wenn vorhin ein Entwurf nicht mehr als Entwurf gespeichert wurde und der Dialog ein paar Zeilen
            // drunter bestätigt
            // nix machen - einfach weiter
        } else if (dlgResult <= 0 && dlgResult > -99) {
            
            return;
        }
        else if (this.entityID && this.isDraft) {

            

            let dlg = new GenericDialog();
            dlg.setup({
                content: "eForms__SubmitDraftWarning_Message",
                header: "eForms__SubmitDraftWarning_Header",
                buttonPreset: "yesno",
                callback: lang.hitch(this, this._onClickSubmit, bSaveAsDraft),
                distinctiveNoCallback: "silentclose",
                contentIconClass: "fas fa-pencil-ruler"
            });
            
            return;

        }
        this.saveForm(bSaveAsDraft);
    }


    private handleErrorResponse(title: string = "General_ErrorOccured", message: string): void {
        if (typeof (this.errorCallback) == "function") {
            this.errorCallback(message);
            return;
        }

        ToasterHelpers.showToast({
            title: title,
            message: message,
            iconClass: ToasterHelpers.ToasterIcons.error
        });
        // ansonsten Fehlermeldung selber irgendwo platzieren?
        console.error(message)
    }

    private handleSuccessResponse(): void {
        if (typeof (this.successCallback) == "function") {
            this.successCallback();
            return;
        }
    }

    private _removeTimeouts() {
        if (this.entity) {
            this._lockEntityForOthers(true);
            if (this._lockCheckHandle) {
                clearTimeout(this._lockCheckHandle);
                this._lockCheckHandle = null;
            }

            if (this._releaseTimeout) clearTimeout(this._releaseTimeout);
        }

        if (this._serializeDataHandle) clearTimeout(this._serializeDataHandle);

        
        this.removeToast("entityLocked");
        this.removeToast("lock");
        this.removeToast("locking");

        this._removeTimeouts = function () { return;  }; // selber überschreiben, damits nicht mehrfach ausgeführt wird
    }

    destroy(): void {

        this._removeTimeouts();
        if (this.entityID == UrlHelpers.getUrlParameterValue("view")) {
            UrlHelpers.removeUrlParameter("view");
        }

        UrlHelpers.removeUrlParameter("ctype");
        UrlHelpers.removeUrlParameter("create");
        super.destroy.apply(this, arguments as any);
    }

}

export default mdsWidget(eFormEditor);